import React from "react";

export default ({ description, colorSectionText }) => (
  <div className="text-sm xl:text-base" style={{ color: colorSectionText }}>
    {description}
  </div>
);
